/**
 * Renders an info icon with a tooltip that shows the child(ren) on hover.
 *
 * If child is just text, it is wrapped in a <p> element.
 */

import React, { ComponentProps, useMemo } from "react";
import Tooltip from "./Tooltip";
import factory from "../../testUtils/factory";
import Box from "../Box";
import Icon from "../Icon";
import { TooltipDirection } from "./TooltipTypes";

type Props = {
  direction?: ComponentProps<typeof Tooltip>["direction"];
  iconId?: string;
  fill?: string;
  interactive?: boolean;
  children: React.ReactNode;
};

const InfoTip: React.FC<Props> = ({
  iconId = "info",
  fill = undefined,
  children,
  direction = TooltipDirection.Top,
  interactive,
  ...rest
}) => {
  const id = useMemo(() => factory.genUUID(), []);
  return (
    <Box
      flexGrow="0"
      ml="s"
      display="inline-flex"
      style={{ verticalAlign: "text-top" }}
      {...rest}
      data-tooltip-source={id}>
      {children && (
        <Tooltip source={id} direction={direction} interactive={interactive}>
          {children}
        </Tooltip>
      )}
      <Icon size="16" iconId={iconId || "info"} fill={fill} style={{ verticalAlign: "text-top" }} />
    </Box>
  );
};

export default InfoTip;
